import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ObjectArrayService {
  public undoItemsList:{[key: number]: number} = {};
}
